<template>
  <el-card shadow="hover" class="chart-card">
    <div slot="header" class="card-header">
      <span>{{ title || '州揽收效率监控 (Monitoramento da eficiência de coleta de estado)' }}</span>
      <img
        :src="exportIcon" class="export-btn" alt="导出"
        @click="handleExport"
      >
    </div>
    <base-echart :options="chartOption" height="290px" />
  </el-card>
</template>

<script>
import BaseEchart from './BaseEchart';

export default {
  name: 'StateEfficiencyChart',
  components: { BaseEchart },
  props: {
    title: {
      type: String,
      default: ''
    },
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartOption: {},
      exportIcon: require('@/assets/images/kanban/endKanbanBoard/Export.svg')
    };
  },
  watch: {
    chartData: {
      handler() {
        this.updateChartOption();
      },
      deep: true
    }
  },
  created() {
    this.updateChartOption();
  },
  methods: {
    updateChartOption() {
      const data = this.chartData || [];

      // 当数据为空时，确保设置空数组（虽然map会自动返回空数组，但显式处理更清晰）
      const xAxisData = data.length > 0 ? data.map((item) => item.purposeState) : [];
      const collectionRateData = data.length > 0
        ? data.map((item) => (Math.round(Number(item.collectionRate) * 10000) / 100).toFixed(2))
        : [];
      const onTimeRateData = data.length > 0
        ? data.map((item) => (Math.round(Number(item.collectionOnTimeRate) * 10000) / 100).toFixed(2))
        : [];

      // 计算默认显示5条数据的结束百分比
      const defaultShowCount = 5;
      const showScrollBar = data.length > 6; // 超过6条才显示滚动条
      // 6条及以下全部显示，超过6条才显示前5条
      const endPercent = data.length <= 6
        ? 100
        : Math.min(100, (defaultShowCount / data.length) * 100);

      this.chartOption = {
        color: ['#2AAB80', '#4581DE'],
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let result = params[0].axisValueLabel + '<br/>';
            params.forEach((param) => {
              result += param.marker + param.seriesName + ': ' + parseFloat(param.value).toFixed(2) + '%<br/>';
            });
            return result;
          }
        },
        legend: {
          data: ['揽收率 Taxa de coleta', '揽收及时率 Taxa de coleta pontual'],
          top: 0,
          icon: 'circle'
        },
        grid: { left: '3%', right: '4%', bottom: showScrollBar ? '15%' : '3%', containLabel: true },
        dataZoom: [
          {
            type: 'slider',
            show: showScrollBar,
            xAxisIndex: [0],
            start: 0,
            end: endPercent,
            height: 20,
            bottom: 5,
            borderColor: '#ccc',
            fillerColor: 'rgba(42, 171, 128, 0.2)',
            handleStyle: {
              color: '#2AAB80'
            }
          }
        ],
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLine: { lineStyle: { color: '#D9D9D9', type: 'dashed' }},
          axisTick: { show: false },
          axisLabel: { color: '#666' }
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLabel: { formatter: '{value}%' },
          splitLine: { show: true, lineStyle: { type: 'dashed', color: '#E0E6F1' }}
        },
        series: [
          {
            name: '揽收率 Taxa de coleta',
            type: 'bar',
            data: collectionRateData,
            barWidth: 10,
            itemStyle: {
              borderRadius: [5, 5, 0, 0],
              shadowColor: 'rgba(42, 171, 128, 0.8)',
              shadowBlur: 6,
              shadowOffsetY: 3
            }
          },
          {
            name: '揽收及时率 Taxa de coleta pontual',
            type: 'bar',
            data: onTimeRateData,
            barWidth: 10,
            itemStyle: {
              borderRadius: [5, 5, 0, 0],
              shadowColor: 'rgba(69, 129, 222, 0.8)',
              shadowBlur: 6,
              shadowOffsetY: 3
            }
          }
        ]
      };
    },

    /**
     * 处理导出
     */
    handleExport() {
      this.$emit('export');
    }
  }
};
</script>

<style scoped lang="scss">
.chart-card {
  margin-bottom: 0;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: none;

  ::v-deep .el-card__header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
    font-size: 16px;
    color: #0f1728;
    font-style: normal;
    text-transform: none;
    font-weight: bold;
    .export-btn {
      width: 16px;
      height: 16px;
      cursor: pointer;
      transition: opacity 0.3s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>
